<template>
  <div class="formField radioField" :class="{ isError, isDisabled, isRound }">
    <div class="radioField__Wrapper">
      <input
        :id="uniqueID"
        :name="name"
        :value="value"
        :disabled="isDisabled"
        :required="isRequired"
        type="radio"
        tabindex="-1"
        v-model="fieldValue"
      />
      <label
        class="radioField__Circle"
        :tabindex="!isDisabled && tabindex === undefined ? 0 : -1"
        @keydown="handleKeyDown"
        :for="uniqueID"
      />
      <div class="radioField__LabelWrapper">
        <label :for="uniqueID" class="radioField__Label form__Label" @click="handleLabelClick">
          <slot>{{ label }}</slot>
        </label>
        <FormError :errors="mergedErrors" className="radioField__Error" />
      </div>
    </div>
  </div>
</template>

<script setup>
  const emit = defineEmits(['update:modelValue'])
  const props = defineProps({
    ...useFormFieldProps(),
    value: {},
    tabindex: {
      type: [Number, String]
    },
    round: {
      type: Boolean,
      default: false
    },
  })

  const { mergedErrors, fieldValue, isDisabled, isRequired, isError, uniqueID, triggerValidate } = useFormField(props, emit)

  defineExpose({
    triggerValidate,
  })

  const isRound = computed(() => props.round)

  const handleKeyDown = e => {
    if ([0, 13, 32].includes(e.keyCode) && !isDisabled.value) {
      e.preventDefault()
      e.target.parentNode.querySelector('[type="radio"]').click()
    }
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/components/forms/_radioField.scss');
</style>
